module.exports = __webpack_public_path__ + "assets/b680066bd36e0443d245b7c722baad25.png";